import { en } from "./en/en";
import { da } from "./da/da";
import { no } from "./no/no";
import { sv } from "./sv/sv";

export const translations = {
	en,
	sv,
	da,
	no,
};

type MergeTranslations<T extends Record<string, unknown>> = {
	[K in keyof T]: T[K];
};

export type TranslationKeys = MergeTranslations<typeof en>;
